module.exports = "/_next/static/images/ne-fe232d8aee68a798c4e7aac73106c02e.svg";